var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSymbolMonochrome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "symbol"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.683 0H130.194L130.317 95.1894L168.639 56.868L183.132 71.4842L144.9 109.683L240 109.683V130.195L144.811 130.317L212.1 197.625L197.596 212.129L130.317 144.811L130.194 240H109.683V144.869L42.3747 212.119L27.8813 197.625L95.1894 130.317L0 130.195V109.683L95.1893 109.683L27.9456 42.3746L42.4496 27.8706L109.683 95.1894V0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.132 42.3746L197.625 27.8813L212.119 42.3746L197.625 56.868L183.132 42.3746Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolMonochrome);
export default __webpack_public_path__ + "static/media/symbol-monochrome.1108f84fb4f63c7efe9f9e4b57e28758.svg";
export { ForwardRef as ReactComponent };